import { useSelector } from 'react-redux';
import { type AppDispatch, type RootState, useAppDispatch } from '../store';
import {
  hideSendNotification,
  hideSendToProtest,
  showSendNotification,
  showSendToProtest,
} from '../store/reducers/ejn-toogle';

export const useEjnActions = () => {
  const dispatch: AppDispatch = useAppDispatch();

  const { sendToProtestVisible, sendNotificationVisible } = useSelector(
    (state: RootState) => state.extrajudicialNotificationsToogleStore,
  );

  const onClose = () => {
    dispatch(hideSendNotification());
    dispatch(hideSendToProtest());
  };

  const showProtestModal = () => dispatch(showSendToProtest());
  const showSendNotificationModal = () => dispatch(showSendNotification());

  return {
    sendToProtestVisible,
    sendNotificationVisible,
    onClose,
    showProtestModal,
    showSendNotificationModal,
  };
};
